import React from 'react';

var TableContext = /*#__PURE__*/React.createContext({
  data: [],
  dataKey: "key"
});
TableContext.displayName = "TableContext";
var TableContext$1 = TableContext;

export { TableContext$1 as default };
